import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const navigationItems = [{
  title: "Forestry Mulching",
  href: "/ForestryMulching",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/machine-cropped.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/machine-cropped.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/machine-cropped.png",
    alt: "Professional forestry mulching and land management"
  }
}, {
  title: "Land Clearing",
  href: "/LandClearing",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/land_clearing_equipment.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/land_clearing_equipment.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/land_clearing_equipment.png-wvc-sizes",
    alt: "Comprehensive land clearing for residential and commercial lots"
  }
}, {
  title: "Property Cleanup",
  href: "/PropertyCleanup",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/property_cleanup_results.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/property_cleanup_results.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/property_cleanup_results.png-wvc-sizes",
    alt: "Complete property cleanup and brush removal services"
  }
}];
export default function NavigationGrid() {
  return <section data-section-id="264075" id="our-services" className="w-full bg-background text-foreground flex flex-col">
      {}
      <div className="bg-secondary py-16 md:py-24 px-6 text-center flex items-center justify-center">
        <h2 className="font-default text-xl md:text-2xl lg:text-3xl max-w-5xl mx-auto text-secondary-foreground leading-relaxed uppercase tracking-widest font-semibold">
          Expert land management solutions with specialized equipment to transform your overgrown property into usable space
        </h2>
      </div>

      {}
      <div className="grid grid-cols-1 md:grid-cols-3 w-full">
        {navigationItems.map((item, i) => <Link key={i} to={item.href} data-index={i} className="group relative block aspect-square md:aspect-[4/5] overflow-hidden">
            <img src={item.image.src} data-wvc-srcset={item.image.srcset} data-wvc-sizes={item.image.sizes} alt={item.image.alt} className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" loading="lazy" />
            {}
            <div className="absolute inset-0 bg-secondary/40 transition-colors duration-700 group-hover:bg-secondary/60" />
            
            {}
            <div className="absolute inset-0 flex items-center justify-center p-6">
              <Button variant="secondary" className="w-full max-w-[260px] h-auto py-4 font-default tracking-widest uppercase text-sm md:text-base rounded-md shadow-lg bg-primary text-primary-foreground border-none transition-transform duration-500 group-hover:-translate-y-2 hover:bg-primary/90">
                {item.title}
              </Button>
            </div>
          </Link>)}
      </div>
    </section>;
}